<div class="user-stats__table user-stats__table--total">
  <app-user-stats-table-header
    [ncells]="4"
    [start]="1"
    [slotAlign]="'right'"
    [icons]="['all_items', 'clock', 'speed']"
    [labels]="['stats.itemsCompleted', 'stats.dedicatedHours', 'stats.pagesHour']">
  </app-user-stats-table-header>

  <app-user-stats-table-row
    [nDataCells]="3"
    [formatIcon]="'format_ebook'"
    [formatLabel]="'formats.ebook'"
    [data]="[
      ebookTotals.totalItems,
      ebookTotals.totalDedicatedHours,
      ebookTotals.totalUnitsPerHour
    ]"
    [isTotalSection]="true">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="3"
    [formatIcon]="'format_audio'"
    [formatLabel]="'formats.audio'"
    [data]="[audioTotals.totalItems, audioTotals.totalDedicatedHours, '--']"
    [isTotalSection]="true">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="3"
    [formatIcon]="'format_video'"
    [formatLabel]="'formats.video'"
    [data]="[videoTotals.totalItems, videoTotals.totalDedicatedHours, '--']"
    [isTotalSection]="true">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="3"
    [formatIcon]="'format_education'"
    [formatLabel]="'formats.scorm'"
    [data]="[scormTotals.totalItems, scormTotals.totalDedicatedHours, '--']"
    [isTotalSection]="true">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="3"
    [formatIcon]="'title_outline'"
    [formatLabel]="'common.total'"
    [data]="[totalItems, totalTime, totalPagesPerHour]"
    [isTotalSection]="true"
    [isEndRow]="true">
  </app-user-stats-table-row>
</div>
